export const MOBILE_BREAKING_POINT = 500;
export const TABLET_BREAKING_POINT = 1200;
export const DESKTOP_LARGE_BREAK_POINT = 1280;

export const physioMeMobileBreakpoint = `(max-width: ${MOBILE_BREAKING_POINT}px)`;
export const physioMeTabletBreakpoint = `(max-width: ${TABLET_BREAKING_POINT}px)`;
export const physioMeDesktopLargeBreakpoint = `(min-width: ${TABLET_BREAKING_POINT}px) and (max-width: ${DESKTOP_LARGE_BREAK_POINT}px)`;
